"use client"

import { Button } from "@/components/ui/button"
import { motion } from "framer-motion"
import Link from "next/link"

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <motion.div
          className="text-center max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <motion.h1
            className="text-6xl sm:text-7xl lg:text-8xl font-bold text-[#FF7A00] mb-4"
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ duration: 3, repeat: Number.POSITIVE_INFINITY }}
          >
            404
          </motion.h1>
          <h2 className="text-2xl sm:text-4xl font-bold text-foreground mb-4">Page Not Found</h2>
          <p className="text-base sm:text-lg text-muted-foreground mb-8">
            Sorry, we couldn't find the page you're looking for. Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link href="/">
              <Button className="bg-[#003DA5] hover:bg-blue-800 text-white font-semibold px-8 py-6 text-base">
                Go Home
              </Button>
            </Link>
            <Link href="/services">
              <Button
                variant="outline"
                className="font-semibold px-8 py-6 text-base border-[#003DA5] text-[#003DA5] bg-transparent"
              >
                Browse Services
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
